import { ChevronRight } from "lucide-react";
import { MoodBadge } from "./Mood";

const ROMAN = ["V", "IV", "III", "II", "I"];

export const TeamCard = ({ group, index, skillsOf, moodOf = () => null, brainOf = () => null, onOpen }) => {
  const [sysLabel, ...rest] = group.subsystem.split(" – ");
  const roman = ROMAN.find((r) => sysLabel.endsWith(` ${r}`));
  return (
    <section className="border border-zinc-900" data-testid={`team-card-${index}`}>
      <header className="flex items-stretch border-b border-zinc-900">
        <div className="w-16 shrink-0 bg-zinc-900 text-white flex items-center justify-center font-grotesk text-xl font-bold">{roman}</div>
        <div className="px-4 py-3 min-w-0 flex-1">
          <div className="font-mono text-[11px] text-zinc-500 truncate" data-testid="team-path">{group.path}</div>
          <h2 className="font-grotesk text-lg font-bold tracking-tight" data-testid="team-name">{rest.join(" – ") || sysLabel}</h2>
        </div>
        <div className="px-4 flex items-center font-mono text-xs text-zinc-500">{group.rows.length}</div>
      </header>
      <ul className="divide-y divide-zinc-100">
        {group.rows.map((r) => {
          const skills = skillsOf(r.employee_id);
          return (
            <li key={r.employee_id}>
              <button onClick={() => onOpen(r.employee_id)} className="w-full text-left px-4 py-3 grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] md:grid-cols-[220px_180px_minmax(0,1fr)_auto] gap-4 items-center hover:bg-zinc-50 transition-colors" data-testid="team-employee-row">
                <span className="min-w-0">
                  <span className="font-medium truncate block">{r.name}</span>
                  <span className="flex items-center gap-3 mt-0.5">
                    {brainOf(r.employee_id) && <span className="font-mono text-[11px] text-zinc-500" data-testid="team-employee-brain">Breintype #{brainOf(r.employee_id)}</span>}
                    <MoodBadge mood={moodOf(r.employee_id)} testid="team-employee-mood" />
                  </span>
                </span>
                <span className="text-sm text-zinc-500 truncate">{r.role || "—"}</span>
                <span className="hidden md:flex flex-wrap gap-1">
                  {skills.slice(0, 4).map((b) => (
                    <span key={b.id} className="border border-zinc-300 px-1.5 py-0.5 text-[11px] text-zinc-700 max-w-[220px] truncate" title={`${b.strategy}: ${b.text}`}>{b.text}</span>
                  ))}
                  {skills.length > 4 && <span className="text-[11px] text-zinc-500 px-1">+{skills.length - 4}</span>}
                  {skills.length === 0 && <span className="text-[11px] text-zinc-400">geen vaardigheden</span>}
                </span>
                <ChevronRight className="h-4 w-4 text-zinc-400" />
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
